import { Component, OnInit, Input, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { from, of, Subject } from 'rxjs';
import { AccountsComponent } from '../accounts/accounts.component';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from "../services/data.service";
import { CommonService } from '../services/common.service';
import { APIService } from './../api.service';
import { TestBed } from '@angular/core/testing';
import { rendererTypeName, ThrowStmt } from '@angular/compiler';
import { FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LacFormatPipe } from '../pipe/lac-format/lac-format.pipe';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SetAcctStartDateComponent } from '../set-acct-start-date/set-acct-start-date.component';

@Component({
	selector: 'app-heads',
	templateUrl: './heads.component.html',
	styleUrls: ['./heads.component.scss']
})
export class HeadsComponent implements OnInit {

	hideZeroLevelLdgr: boolean = false;
    @ViewChild('ledgerEntry') ledgerEntryMdl!: ElementRef;

	@Input() changingHead: Subject<boolean> = new Subject();
	changingValue: Subject<boolean> = new Subject();
	changingHeadValue: Subject<boolean> = new Subject();
	// @ViewChild('editGroup', { static: true }) EditGroup!: ElementRef;
	@Input() accountDates: Subject<{
    	fdt: Date,
    	tdt: Date,
    	selectedFy: String
  	}> = new Subject();
  	compRules = {
    	isB2C: false
  	};
  	//Variables
  	jarvisData: any = [];
  	right: any;
  	bankList: any = [];
  	GSTLedgerList : any = [];
  	//isB2CMode: boolean = false;
  	isWeb: boolean = true;
    acctStartDT: any = new Date();

  	constructor(public accountsComponent: AccountsComponent, private headService: DataService,
    	private appService: DataService, private modalService: NgbModal, private apiService: APIService,
    	private deviceService: DeviceDetectorService, private _Activatedroute: ActivatedRoute,
    	private SpinnerService: NgxSpinnerService, public CmnService: CommonService) {
  	}

  	ngOnInit(): void {
    	this.isWeb = this.apiService.apiCheckWeb();

    	var jarvis = this.apiService.getCookie("Jarvis");
    	if (jarvis) {
      		this.jarvisData = JSON.parse(jarvis);
    	}

    	let agencyData = this.apiService.getCookie("M");
    	if (agencyData) {
      		this.agencyData = JSON.parse(agencyData);
      		this.compRules.isB2C = this.agencyData[0].IsB2C;
    	}

    	this.NameFilter.valueChanges
      	.subscribe(
        	NameFilter => {
          		this.filterValues.Name = NameFilter;
          		this.dataSource.filter = JSON.stringify(this.filterValues);
        	}
      	)
    	this.OpBalFilter.valueChanges
      	.subscribe(
        	OpBalFiltert => {
          		this.filterValues.OpBal = OpBalFiltert;
          		this.dataSource.filter = JSON.stringify(this.filterValues);
        	}
      	)
    	this.CrAmtFilter.valueChanges
      	.subscribe(
        	CrAmtFilter => {
          		this.filterValues.CrAmt = CrAmtFilter;
          		this.dataSource.filter = JSON.stringify(this.filterValues);
        	}
      	)
    	this.DbAmtFilter.valueChanges
      	.subscribe(
        	DbAmtFilter => {
          		this.filterValues.DbAmt = DbAmtFilter;
          		this.dataSource.filter = JSON.stringify(this.filterValues);
        	}
      	)
		this.CloBalFilter.valueChanges
		.subscribe(
			CloBalFiltert => {
				this.filterValues.CloBal = CloBalFiltert;
				this.dataSource.filter = JSON.stringify(this.filterValues);
			}
		)

		this.changingHead.subscribe(v => {
			this.balanceSheetData.id = this._Activatedroute.snapshot.params['id'];
			this.balanceSheetData.h = this._Activatedroute.snapshot.params['h'];
			this.getData(1);
		});

		this.changingHeadValue.subscribe(v => {
			debugger;
			this.getData(1);
		});

		// this.headService.headData.subscribe(data => {
		//    if((data && data.length > 0) || (data && data > 0)) {
		//     // let htmlDiv: any = $('#mdlGroupEditLedger').html;
		//      this.opeEditDeleetPopup("editGroup", false, data)
		//    }
		//  });

		this.appService.tmpVoucherEntered.subscribe(v => {
			if (v == 1) {
				this.getData(1);
				this.appService.updateVoucherEntered(0);
			}
		})

		this.appService.tmpFinancialYearChange.subscribe(v => {
			if (v == 1) {
				// this.balanceSheetData.id = this._Activatedroute.snapshot.params['id'];
				// this.balanceSheetData.h = this._Activatedroute.snapshot.params['h'];
				this.getData(0);
			}
		});


		var erpAgnCookie = this.apiService.getCookie("ERP_Agn");
		var erpAgnencyInfo: any = [];
		if (erpAgnCookie) {
			erpAgnencyInfo = JSON.parse(erpAgnCookie);
            this.acctStartDT = erpAgnencyInfo.length > 0 && erpAgnencyInfo[0].AccountStartDT ? new Date(erpAgnencyInfo[0].AccountStartDT).customFormat('#DD#-#MMM#-#YY#') : '';
		}
		
		var ledger = this.apiService.getCookie('Ledger');
		if (ledger) {
			this.ledgersData = JSON.parse(ledger);
		}

    	this.right = this.apiService.getCookie("J");
    	if(this.right) {
      		this.right = JSON.parse(this.right);
      		let ownUserID: number = this.jarvisData[0].UserID;
      		if(this.agencyData[0].AdminUserID == ownUserID) {
				this.right = {
					Accts: true,
					AcctsCfg: true,
					AcctsVchrEntry: true,
					ConnAppt: true,
					ConnEdit: true,
					ConnEntry: true,
					ConnInxn: true,
					ConnReference: true,
					ConnViewTypeID: 1,
					CstrEdit: true,
					CstrEntry: true,
					CstrViewTypeID: 1,
					CtrcEdit: true,
					CtrcEntry: true,
					CtrcViewTypeID: 1
				}
			}
      		else {
        		this.right = $.grep(this.right, function(o: any){ return o.UserID == ownUserID })[0];
        		if(!this.right.Accts && !this.right.AcctsVchrEntry && !this.right.AcctsCfg){
          			window.location.href = "main.html#/home";
          			return;
				}
      		}
    	}

		this.financialYears = this.checkFinancialYear(new Date("2015"), new Date());
		this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
		let currentDate = new Date();
		this.fn_Set_FinancialYear(currentDate);
		this.balanceSheetData.id = this._Activatedroute.snapshot.params['id'];
		this.balanceSheetData.h = this._Activatedroute.snapshot.params['h'];

		if(!this.balanceSheetData.id) {
			let selectedHeadID: any = this.apiService.getCookie("slectedHeadID");
			if(selectedHeadID && selectedHeadID != "undefined"){
				this.balanceSheetData.id = selectedHeadID;
				this.balanceSheetData.h = 1;
			}

			let selectedLeaderID: any = this.apiService.getCookie("slectedLeaderID");
			if(selectedLeaderID && selectedLeaderID != "undefined" && selectedLeaderID > 0){
				this.balanceSheetData.id = selectedLeaderID;
				this.balanceSheetData.h = 0;
			}
		}

		let lParam: any = this._Activatedroute.snapshot.queryParams['l'];
		if(lParam && lParam == 1) {
			setTimeout(() => {
				this.openLedgerModal(this.ledgerEntryMdl, true);
			}, 500);
		}
  	}


	tmpLedger: any = [];
	favLedger: any = [];
	favLedgerList: any = [];
	heads: any = [];
	headsData: any = [];
	subHead: any = [];
	tree: any = [];
	ledger: any = [];
	ledgerData: any = [];
	ledgersData: any = [];
	isShowHeads: boolean = true;
	isShowSubHeads: boolean = false;
	isShowSearch: boolean = false;
	isHeadEdit: boolean = false;
	isMobileView: boolean = this.deviceService.isMobile();
	isFav: boolean = false;
	search: string = '';
	closeResult: string = '';
	subHeadList: any = [];
	displayData: any = [];
	data: any = [];
	displayedColumns: string[] = ['name', 'OpBal', 'DbAmt', 'CrAmt', 'CloBal', 'isHead'];
	connections: any = [];
	customers: any = [];
	suppliers: any = [];
	balanceSheetData = {
		id: 0,
		h: 0
	};
	query: any;
	fromDate: any;
	toDate: any;
	selectedDate: any;
	selectedFY: any;
	financialYears: any = [];
	agencyData: any = [];
	isShowLoading: boolean = false;

	NameFilter = new FormControl('');
	OpBalFilter = new FormControl('');
	CrAmtFilter = new FormControl('');
	DbAmtFilter = new FormControl('');
	CloBalFilter = new FormControl('');
	dataSource = new MatTableDataSource();

	filterValues = {
		Name: '',
		OpBal: '',
		CrAmt: '',
		DbAmt: '',
		CloBal: ''
	};

	newGroup = {
		parantGroupName: '0',
		newGroupName: '',
		groupId: 0
	};

	newLedger = {
		accountHead: '0',
		ledgerName: '',
		openingBal: 0,
		curr: 'Cr',
		id: 0,
		type: 0,
		isCustomer: false,
		customerId: 0,
		customerName: '',
		isSupplier: false,
		supplierId: 0,
		supplierName: '',
		isBank: false,
		isCash: false,
		isEmployee: false,
	};

	bank = {
		name: '',
		branch: '',
		accNo: '',
		ifsc: '',
		bankID: 0
	};

	modalReference: any;
	isShowZeroBal: boolean = false;

	isShowsetting: boolean = false;
	isShowConfig: boolean = false;

	//Functions
	getData(id: number) {
		//Get cookie data
		// let accountsDate: any = this.apiService.getCookie("AccountsDates");
		// if (accountsDate) {
		//   accountsDate = JSON.parse(accountsDate);
		//   if (accountsDate.length > 0) {
		//     this.fromDate = accountsDate[0].fdt;
		//     this.toDate = accountsDate[0].tdt;
		//   }
		// }
		if(this.accountDates) {
		this.accountDates.subscribe(dates => {
			this.fromDate = dates.fdt;
			this.toDate = dates.tdt;
		})
		}

		// let currDT = new Date()
		// let currFY = this.CmnService.getCurrentFinancialYear(currDT).split('-');
		// let currFYYear: string = '';
		// let isQuickMode = false;
		// if (currDT.getMonth() > 3) {
		//   currFYYear = currFY[0].toString()
		// } else {
		//   currFYYear = (Number(currFY[1]) - 1).toString()
		// }

		let currDT = new Date();
		let currFYYear: string;
		let isQuickMode = false;
		if (currDT.getMonth() >= 3) { // If month is April or later, then current FY is currFYYear
		currFYYear = currDT.getFullYear().toString();
		} else { // If month is before April, then current FY is currFYYear - 1
		currFYYear = (currDT.getFullYear() - 1).toString();
		}
		
		if (new Date(this.fromDate).customFormat("#DD#-#MMM#-#YYYY#") == ('01-Apr-' + currFYYear) && new Date(this.toDate) >= new Date(new Date().customFormat("#DD#-#MMM#-#YYYY#"))) {  // this.toDate >= currentDate
		isQuickMode = true;
		}

		let data = [{
			fromDT: new Date(this.fromDate).customFormat("#DD#-#MMM#-#YY#"),
			toDT: new Date(this.toDate).customFormat("#DD#-#MMM#-#YY#"),
			isQuickMode: isQuickMode,
			calledFrom: 'DSBD'
		}];
		
		let myParams = [{
			myUserID: this.jarvisData[0].UserID,
			myToken: this.jarvisData[0].WebToken,
			forAgencyID: this.jarvisData[0].AgencyIDs,
			myAgencyIDs: this.jarvisData[0].AgencyIDs,
			myLastSyncDT: null,
			isWeb: true,
			ForERPAgencyID: this.agencyData[0].ERPAgencyID,
			actionType: 'get',
			moduleID: 1,
			data: JSON.stringify(data)
		}];

		this.isShowLoading = true;
		// Get Ledgers and Vouchers
		this.apiService.getData(myParams, this.successResp.bind(this, id), this.failureResp.bind(this));

		//Get H from IDB
		var self = this;
		var tblH = this.apiService.getIDB('H', function(dataList: any){
			if(dataList){
				self.connections = dataList;
			}
		})
	}

  //Click on sub-group
  openSubHead(i: any) {
    //Open Sub-group
    //this.accountsComponent.isShowRVoucher = true;
    this.apiService.setCookie("slectedHeadID", 0);
    this.apiService.setCookie("slectedLeaderID", 0);
    if (i.isHead == true) {
      this.apiService.setCookie("slectedHeadID", i.id);
      this.headsData = $.grep(this.heads, (e: any) => { return (e.ParentHeadID == i.id) });
      this.ledgerData = $.grep(this.ledger, (e: any) => { return (e.HeadID == i.id) });

      this.dataPush();
      let obj = {
        headID: i.id,
        parentHeadID: i.parentHeadID,
        headName: i.name,
        headLevel: i.headLevel
      }

      let alreadyExist: Array<any> = this.tree.filter((x: any) => x.headID == i.id);
      if(alreadyExist.length == 0){
        this.tree.push(obj)
      }
      this.isShowSubHeads = true;
    }

    //Open Ledger
    else {
      this.apiService.setCookie("slectedLeaderID", i.id);
      this.openLedger(i);
    }

  }

  //customerChange() - Customer Change
  customerChange() {

    let tmpCustList: Array<any> = this.customers.filter((x: any) => x.Cmp == this.newLedger.customerName);
    if (tmpCustList.length > 0) {
      this.newLedger.customerId = tmpCustList[0].RI;
    }
  }

  //supplierChange() - Supplier Change
  supplierChange() {
    let tmpCustList: Array<any> = this.suppliers.filter((x: any) => x.Cmp == this.newLedger.supplierName);
    if (tmpCustList.length > 0) {
      this.newLedger.supplierId = tmpCustList[0].RI;
    }
  }

  //Click on tree name
  treeIndex(i: any, t: any, isFromOtherPage: boolean) {
    this.headsData = $.grep(this.heads, (e: any) => { return (e.ParentHeadID == i.headID) })
    this.ledgerData = $.grep(this.ledger, (e: any) => { return (e.HeadID == i.headID) })
    // if(this.headsData.length > 0){
    //   this.isShowsetting = true;
    // }else{
    //   this.isShowsetting = false;
    // }
    this.dataPush();

    // console.log(this.heads)
    // this.apiService.setCookie("heads", JSON.stringify(this.heads));
    //Remove from tree

    if (isFromOtherPage == false) {
      this.tree.splice(t + 1, this.tree.length - 1);
    }
  }

  allHeads() {
    //Open all heads
    this.tree = [];
    this.ledgerData = [];
    this.headsData = [];
    this.displayData = [];
    this.isShowSubHeads = false;
    this.headsData = $.grep(this.heads, (e: any) => { return e.ParentHeadID == 0 })


    this.dataPush();
  }

  //Click on ledger
  openLedger(obj: any) {
    //Open ledger side
    if (!this.isMobileView) {
      this.expandView(obj)
    } else {
      this.accountsComponent.isShowRVoucher = false;
      this.appService.updateData(obj);
      if (this.isMobileView) {
        this.accountsComponent.isShowRVoucherMob = true;
      }
    }

  }

  ledgerType(id: any) {
    //Select ledger type in ledger Entry/Edit modal
    this.newLedger.customerId = 0;
    this.newLedger.supplierId = 0;

    this.newLedger.isCustomer = false;
    this.newLedger.isSupplier = false;
    this.newLedger.isBank = false;
    this.newLedger.isCash = false;
    this.newLedger.isEmployee = false;

    this.newLedger.type = id;
    id == 1 ? this.newLedger.isCustomer = true : id == 2 ? this.newLedger.isSupplier = true : id == 3 ? this.newLedger.isBank = true : id == 4 ? this.newLedger.isCash = true : this.newLedger.isEmployee = true;
  }

  resetNewGroup() {
    this.newGroup = {
      parantGroupName: '0',
      newGroupName: '',
      groupId: 0
    };
  }

  openSubgroupModal(content: any) {
    this.modalReference.close();
    this.resetNewGroup()
    this.newGroup.parantGroupName = this.tree.length > 0 ? this.tree[this.tree.length - 1].headID : '0';
    this.modalReference = this.modalService.open(content, { windowClass: "subGroupModalClass", backdrop: 'static', keyboard: false });
  }

  resetNewLedger() {

    this.newLedger = {
      accountHead: '0',
      ledgerName: '',
      openingBal: 0,
      curr: 'Cr',
      id: 0,
      type: 0,
      isCustomer: false,
      customerId: 0,
      customerName: '',
      isSupplier: false,
      supplierId: 0,
      supplierName: '',
      isBank: false,
      isCash: false,
      isEmployee: false
    };
  }

	openLedgerModal(content: any, ignoreAcctMdl: boolean = true) {
        if (!ignoreAcctMdl) {
            var ledger = this.apiService.getCookie('Ledger');
            if (ledger) {
                this.ledgersData = JSON.parse(ledger);
            } else {
                this.ledgersData = [];
            }

            let enteredLedgers: Array<any> = $.grep(this.ledgersData, (x: any) => { return x.LedgerName != 'Profit & Loss A/c' })

            if (enteredLedgers.length == 0) {
                this.openAskAcctStartDT();
                return;
            }
        }
		//this.modalReference.close();
		this.customers = $.grep(this.connections, (e: any) => { return (e.C == true) });
		this.suppliers = $.grep(this.connections, (e: any) => { return (e.S == true) });

		this.resetNewLedger();
		this.newLedger.accountHead = this.tree.length > 0 ? this.tree[this.tree.length - 1].headID : '0';
		this.isShowZeroBal = false;
		this.modalReference = this.modalService.open(content, { windowClass: "ledgerModalClass", backdrop: 'static', keyboard: false });
		$('#txtNewLedger').focus();
	}

  saveGroup() {
    let tmpHead = $.grep(this.heads, (e: any) => { return (e.HeadName == this.newGroup.newGroupName) })

    if (this.newGroup.newGroupName == '') {
      alert('Please enter new group name.');
    }
    else if (tmpHead.length > 0) {
      alert('Duplicate group name found.');
    }
    else if (!this.newGroup.parantGroupName || this.newGroup.parantGroupName == '0') {
      alert('Please select a parent group.');
    }
    else {
      let head = $.grep(this.heads, (e: any) => { return (e.HeadID == Number(this.newGroup.parantGroupName)) })
      let obj = [{
        headName: this.newGroup.newGroupName,
        parentHeadID: head[0].HeadID,
        createdUserID: 0
      }];

      this.sendChanges(obj, 1, 'set');
    }
  }

  successGroupEntry(res: any) {
    if (res.error) {
      alert(res.message);
    }
    else {
      this.getData(2);
      this.removeCookie("LdgrsForVhcr");
      alert(res.message);
      this.getBankData();
    }
  }

  saveLedger() {
    let tmpLedger = $.grep(this.ledger, (e: any) => { return (e.LedgerName == this.newLedger.ledgerName) });

    if (this.newLedger.accountHead == '0') {
      alert('Please select group head.')
    }

    else if (this.newLedger.ledgerName == '') {
      alert('Please enter ledger name.')
    }

    else if (tmpLedger.length > 0) {
      alert('Duplicate ledger name found.');
    }

    else if (this.newLedger.isCustomer && this.newLedger.customerId == 0) {
      alert('Please select customer.');
    }

    else if (this.newLedger.isSupplier && this.newLedger.supplierId == 0) {
      alert('Please select supplier.');
    }

    else if (this.newLedger.isBank && (!this.bank.name)) {
      alert('Please enter a bank name.');
      return;
    }

    else if (this.newLedger.isBank && (!this.bank.branch)) {
      alert('Please enter a branch.');
      return;
    }

    else if (this.newLedger.isBank && (!this.bank.ifsc)) {
      alert('Please enter a IFSC code.');
      return;
    }

    else if (this.newLedger.isBank && (!this.bank.ifsc)) {
      alert('Please enter an account number.');
      return;
    }
    else {
      let head = $.grep(this.heads, (e: any) => { return (e.HeadID == Number(this.newLedger.accountHead)) });
      let cust = $.grep(this.customers, (e: any) => { return (e.RI == Number(this.newLedger.customerId)) });
      let supp = $.grep(this.suppliers, (e: any) => { return (e.RI == Number(this.newLedger.supplierId)) });
      let obj = [{
        ledgerName: this.newLedger.ledgerName,
        headID: head[0].HeadID,
        openingBal: this.newLedger.curr == 'Cr' ? '-' + this.newLedger.openingBal : this.newLedger.openingBal,
        userID: 0,
        isCustomer: this.newLedger.isCustomer,
        isSupplier: this.newLedger.isSupplier,
        isBank: this.newLedger.isBank,
        isCash: this.newLedger.isCash,
        isEmployee: this.newLedger.isEmployee,
        relID: this.newLedger.isCustomer ? cust[0].RI : this.newLedger.isSupplier ? supp[0].RI : 0,
        relAgencyID: this.newLedger.isCustomer ? cust[0].RAID : this.newLedger.isSupplier ? supp[0].RAID : 0,
        bankName: this.bank.name ? this.bank.name : '',
        branch: this.bank.branch ? this.bank.branch : '',
        IFSC: this.bank.ifsc ? this.bank.ifsc : '',
        accountNo: this.bank.accNo ? this.bank.accNo : ''
      }];
      this.sendChanges(obj, 2, 'set');
    }
  }

  openExpandModal(expand: any) {
    this.modalReference = this.modalService.open(expand, { windowClass: "myCustomModalClass", backdrop: 'static', keyboard: false });
  }

  // favLedger(obj: any) {
  //   
  //   this.appService.favLedgerData.subscribe((value: any) => {
  //     if (value.fromHome == true) {
  //       this.tmpLedger.push(value);

  //       this.favLedger1 = [];
  //       this.tmpLedger.forEach((element: any) => {
  //         if (element.IsFav == true) {
  //           element.CloBal.charAt(0) == "-" ? element.ClosingBal = element.CloBal.substring(1) + ' Cr' : element.ClosingBal = element.CloBal + ' Db';
  //           this.favLedger1.push({
  //             name: element.LedgerName,
  //             currentBal: element.OpBal,
  //             isFav: element.IsFav,
  //             id: element.id,
  //             ClosingBal: element.CloBal
  //           });
  //         }
  //       });
  //     }

  //     else {
  //       this.tmpLedger = value;

  //       this.favLedger1 = [];
  //       this.tmpLedger.forEach((element: any) => {
  //         if (element.IsFav == true) {
  //           element.CloBal.charAt(0) == "-" ? element.ClosingBal = element.CloBal.substring(1) + ' Cr' : element.ClosingBal = element.CloBal + ' Db';
  //           this.favLedger1.push({
  //             name: element.LedgerName,
  //             currentBal: element.OpBal,
  //             isFav: element.IsFav,
  //             id: element.LedgerID,
  //             ClosingBal: element.CloBal
  //           });
  //         }
  //       });
  //     }

  //     // this.dataSource.data = this.favLedger1;
  //     // this.dataSource.filterPredicate = this.createFilter();
  //   })


  //   if (this.favLedger1.length >= 6) {
  //     alert("You can add only 6 ledger")
  //   }
  //   else {
  // if (this.favLedger1.length >= 5) {
  //   alert("You can add only 5 ledger")
  // }
  // else {

  //     obj.fromHome = true;
  //     this.isFav = true;

  //     this.appService.updateData(obj);
  //     let opBal = parseFloat(obj.OpBal.replace(/,/g, ''));
  //     opBal = Number(opBal);

  //     let obj2 = [{
  //       ledgerName: obj.name,
  //       ledgerID: obj.id,
  //       openingBal: opBal,
  //       userID: 0,
  //       isFav: obj.IsFav,
  //       headID: obj.HeadID,
  //       isCustomer: obj.IsCustomer,
  //       isSupplier: obj.IsSupplier,
  //       relID: obj.RelID,
  //       relAgencyID: obj.RelAgencyID,
  //       bankName: obj.BankName,
  //       branch: obj.Branch,
  //       IFSC: obj.IFSCCode,
  //       accountNo: obj.AccountNo,
  //       BankID: obj.BankID,
  //       isBank: obj.IsBank
  //     }];

  //     this.sendChanges(obj2, 2, 'edit');
  //   }
  // }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {

    }
    else {
      alert(res.message);
    }
  }

  //successResp - success  get handler
  successResp(id: number, res: any) {
    if (res.error) {
      this.isShowLoading = false;
    }
    else {
      if (res) {
        let isHideZero = this.apiService.getCookie("hideZero");
        if(isHideZero){
          this.hideZeroLevelLdgr = isHideZero == "true" ? true : false;
        }

        this.isShowLoading = false;
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          this.data = reponseData;
          this.heads = this.data.Table2;
          this.ledger = this.data.Table1;
          // console.log("Heads", this.heads);
          this.ledgersData = this.ledger;

          //console.log(this.heads)
          this.apiService.setCookie("Heads", JSON.stringify(this.heads));

          if (this.heads.length == 0) {
            alert('Please initialize your Accounts setup.');
            window.location.href = "../../main.html";
            return;
          }

          if (this.ledger.length > 0) {
            this.accountsComponent.isShowVoucherBtn = true;
            if (this.isFav == true) {
              //this.accountsComponent.ledgers = this.ledger;
            }
          }

          this.appService.getFavLedger(this.ledger);

          //this.apiService.setCookie("Ledger", JSON.stringify(this.ledger));
          //this.isFav = false;

          this.apiService.setCookie("Ledger", JSON.stringify(this.ledger))
         
          //When open from balancesheet
          if (this.balanceSheetData.id > 0) {
            if (this.balanceSheetData.h == 0) {
              let tmpLedger = this.ledger.filter((l: any) => { return l.LedgerID == this.balanceSheetData.id });
              let levelPath = tmpLedger[0].LevelPath.split('~');
              levelPath = levelPath.filter((el: any) => {
                return el != "";
              })
              levelPath.forEach((l: any) => {
                this.heads.forEach((h: any) => {
                  if (h.HeadID == l) {
                    let alreadyExist: Array<any> = this.tree.filter((x: any) => x.headID == h.HeadID);
                    if(alreadyExist.length == 0){
                      this.tree.push({
                        headID: h.HeadID,
                        parentHeadID: h.ParentHeadID,
                        headName: h.HeadName,
                        headLevel: h.ParentHeadID
                      });
                    }

                    
                  }
                });
              });

              this.treeIndex(this.tree[this.tree.length - 1], 0, true);
              this.isShowSubHeads = true;

              this.openLedger({ id: this.balanceSheetData.id, name: tmpLedger[0].LedgerName });

            }
            else {
              let tmpGroup = this.heads.filter((h: any) => { return h.HeadID == this.balanceSheetData.id });
              let levelPath = tmpGroup[0].LevelPath.split('~');
              levelPath = levelPath.filter((el: any) => {
                return el != "";
              })

              levelPath.forEach((l: any) => {
                for (let h = 0; h < this.heads.length; h++) {
                  if (this.heads[h].HeadID == l) {

                    let alreadyExist: Array<any> = this.tree.filter((x: any) => x.headID == this.heads[h].HeadID);
                    if(alreadyExist.length == 0){
                      this.tree.push({
                        headID: this.heads[h].HeadID,
                        parentHeadID: this.heads[h].ParentHeadID,
                        headName: this.heads[h].HeadName,
                        headLevel: this.heads[h].ParentHeadID
                      });
                    }
                    
                    break;
                  }
                }

                // this.heads.forEach((h: any) => {
                //   if (h.HeadID == l) {
                //     this.tree.push({
                //       headID: h.HeadID,
                //       parentHeadID: h.ParentHeadID,
                //       headName: h.HeadName,
                //       headLevel: h.ParentHeadID
                //     });
                //   }
                // });
              });
              this.treeIndex(this.tree[this.tree.length - 1], 0, true);
              this.isShowSubHeads = true;
            }            
          }


          //When Page Load
          if ((id == 1) && (this.balanceSheetData.id == 0)) {
            this.headsData = $.grep(this.heads, (e: any) => { return e.ParentHeadID == 0 })
            this.dataPush();
            this.appService.updateLedger(this.ledger);
          }

          //When Successfully Entry Done
          else {

            if (this.isShowSubHeads) {
              this.headsData = $.grep(this.heads, (e: any) => { return (e.ParentHeadID == this.tree[this.tree.length - 1].headID) })
              this.ledgerData = $.grep(this.ledger, (e: any) => { return (e.HeadID == this.tree[this.tree.length - 1].headID) })
            }
            else {
              this.headsData = $.grep(this.heads, (e: any) => { return e.ParentHeadID == 0 })
            }

            this.dataPush();
          }

          if(this.balanceSheetData.id > 0){
            this.balanceSheetData.id = 0;
          }

        }
      }
    }
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data: any, filter: any): boolean {
      let searchTerms = JSON.parse(filter);
      return data.name.toLowerCase().indexOf(searchTerms.Name) !== -1
        && data.OpBal.toString().toLowerCase().indexOf(searchTerms.OpBal) !== -1
        && data.CrAmt.toString().toLowerCase().indexOf(searchTerms.CrAmt) !== -1
        && data.DbAmt.toString().toLowerCase().indexOf(searchTerms.DbAmt) !== -1
        && data.CloBal.toString().toLowerCase().indexOf(searchTerms.CloBal) !== -1;
    }
    return filterFunction;
  }

  openEditGroupModal(content: any, obj: any) {
    this.customers = $.grep(this.connections, (e: any) => { return (e.C == true) });
    this.suppliers = $.grep(this.connections, (e: any) => { return (e.S == true) });

    if (obj.isHead == true) {
      this.isHeadEdit = true;
      this.newLedger.openingBal = 0;
      this.newGroup.groupId = obj.id;
      this.newGroup.newGroupName = obj.name;
      this.modalReference = this.modalService.open(content, { windowClass: "subGroupModalClass", backdrop: 'static', keyboard: false });
    }

    else {
      this.isHeadEdit = false;
      this.newLedger.ledgerName = obj.name;
      
      this.newLedger.id = obj.id;
      this.newLedger.accountHead = obj.HeadID;

      this.newLedger.isCustomer = obj.IsCustomer
      this.newLedger.isSupplier = obj.IsSupplier
      this.newLedger.isBank = obj.IsBank;
      this.newLedger.isCash = obj.IsCash;

      if(obj.LedgerOpeningBal != 0){
        this.isShowZeroBal = true;
      }
      else{
        this.isShowZeroBal = false;
      }

      if(obj.LedgerOpeningBal < 0){
        this.newLedger.curr = 'Cr';
        this.newLedger.openingBal = Number(String(obj.LedgerOpeningBal).replace('-', ''));
      }
      else{
        this.newLedger.curr = 'Db';
        this.newLedger.openingBal = obj.LedgerOpeningBal;
      }
      if (this.newLedger.isCustomer) {
        this.newLedger.type = 1
        let tempCstmr = this.connections.filter((x: any) => x.RI == obj.RelID);
        if (tempCstmr.length > 0) {
          this.newLedger.customerId = tempCstmr[0].RI;
          this.newLedger.customerName = tempCstmr[0].Cmp;
        }
        else {
          this.newLedger.customerId = 0;
          this.newLedger.customerName = ''
        }
      }
      if (this.newLedger.isSupplier) {
        this.newLedger.type = 2
        let tempsplr = this.connections.filter((x: any) => x.RI == obj.RelID)
        if (tempsplr.length > 0) {
          this.newLedger.supplierId = tempsplr[0].RI
          this.newLedger.supplierName = tempsplr[0].Cmp;
        }
        else {
          this.newLedger.supplierId = 0
          this.newLedger.supplierName = ''
        }
      }
      if(this.newLedger.isCash){
        this.newLedger.type = 4;
      }

      if (this.newLedger.isBank) {
        this.bank.name = obj.BankName;
        this.bank.branch = obj.Branch;
        this.bank.accNo = obj.AccountNo;
        this.bank.ifsc = obj.IFSCCode;
        this.bank.bankID = obj.BankID;
        this.newLedger.type = 3
      }
      else{
        this.bank.name = '';
        this.bank.branch = '';
        this.bank.accNo = '';
        this.bank.ifsc = '';
        this.bank.bankID = 0;
      }


      this.modalReference = this.modalService.open(content, { windowClass: "ledgerModalClass", backdrop: 'static', keyboard: false });
    }
  }

  //opeEditDeleetPopup() -
  opeEditDeleetPopup(content: any, isHead: boolean, ledgerID: number) {
    let obj: object = {};
    if (isHead == true) {
      let selectedHeadID: number = this.tree[this.tree.length - 1].headID;
      let tmpHeadObj: Array<any> = $.grep(this.heads, (e: any) => { return (e.HeadID == selectedHeadID) });
      tmpHeadObj[0].CloBal.charAt(0) == "-" ? tmpHeadObj[0].ClosingBal = tmpHeadObj[0].CloBal.substring(1) + ' Cr' : tmpHeadObj[0].ClosingBal = tmpHeadObj[0].CloBal + ' Db';
      tmpHeadObj[0].CrAmt < 0 ? tmpHeadObj[0].CraditAmount = Math.abs(tmpHeadObj[0].CrAmt) + ' Db' : tmpHeadObj[0].CraditAmount = tmpHeadObj[0].CrAmt + ' Cr';
      tmpHeadObj[0].DbAmt < 0 ? tmpHeadObj[0].DebitAmount = Math.abs(tmpHeadObj[0].DbAmt) + ' Db' : tmpHeadObj[0].DebitAmount = tmpHeadObj[0].DbAmt + ' Cr';
      tmpHeadObj[0].OpBal < 0 ? tmpHeadObj[0].OpeningBalance = Math.abs(tmpHeadObj[0].OpBal) + ' Db' : tmpHeadObj[0].OpeningBalance = tmpHeadObj[0].OpBal + ' Cr';

      obj = {
        name: tmpHeadObj[0].HeadName,
        currentBal: tmpHeadObj[0].CrAmt,
        id: tmpHeadObj[0].HeadID,
        parentHeadID: tmpHeadObj[0].ParentHeadID,
        headLevel: tmpHeadObj[0].LevelPath,
        isHead: true,
        CloBal: tmpHeadObj[0].CloBal,
        CrAmt: tmpHeadObj[0].CrAmt,
        DbAmt: tmpHeadObj[0].DbAmt,
        OpBal: tmpHeadObj[0].OpBal,
        ClosingBal: tmpHeadObj[0].ClosingBal,
        CraditAmount: tmpHeadObj[0].CraditAmount,
        DebitAmount: tmpHeadObj[0].DebitAmount,
        OpeningBalance: tmpHeadObj[0].OpeningBalance,
        LedgerType: tmpHeadObj[0].LedgerType
      }
    }
    else {
      let tmpHeadObj: Array<any> = $.grep(this.ledgerData, (e: any) => { return (e.LedgerID == ledgerID) });

      tmpHeadObj[0].CloBal.charAt(0) == "-" ? tmpHeadObj[0].ClosingBal = tmpHeadObj[0].CloBal.substring(1) + ' Cr' : tmpHeadObj[0].ClosingBal = tmpHeadObj[0].CloBal + ' Db';
      tmpHeadObj[0].CrAmt < 0 ? tmpHeadObj[0].CraditAmount = Math.abs(tmpHeadObj[0].CrAmt) + ' Cr' : tmpHeadObj[0].CraditAmount = tmpHeadObj[0].CrAmt + ' Db';
      tmpHeadObj[0].DbAmt < 0 ? tmpHeadObj[0].DebitAmount = Math.abs(tmpHeadObj[0].DbAmt) + ' Cr' : tmpHeadObj[0].DebitAmount = tmpHeadObj[0].DbAmt + ' Db';
      tmpHeadObj[0].OpBal < 0 ? tmpHeadObj[0].OpeningBalance = Math.abs(tmpHeadObj[0].OpBal) + ' Cr' : tmpHeadObj[0].OpeningBalance = tmpHeadObj[0].OpBal + ' Db';

      obj = {
        name: tmpHeadObj[0].LedgerName,
        currentBal: tmpHeadObj[0].CrAmt,
        id: tmpHeadObj[0].LedgerID,
        openingBal: tmpHeadObj[0].OpBal,
        isHead: false,
        balanceHistory: tmpHeadObj[0].balanceHistory,
        CloBal: tmpHeadObj[0].CloBal,
        CrAmt: tmpHeadObj[0].CrAmt,
        DbAmt: tmpHeadObj[0].DbAmt,
        OpBal: tmpHeadObj[0].OpBal,
        HeadID: tmpHeadObj[0].HeadID,
        IsCustomer: tmpHeadObj[0].IsCustomer,
        IsFav: tmpHeadObj[0].IsFav,
        IsSupplier: tmpHeadObj[0].IsSupplier,
        RelAgencyID: tmpHeadObj[0].RelAgencyID,
        RelID: tmpHeadObj[0].RelID,
        ClosingBal: tmpHeadObj[0].ClosingBal,
        CraditAmount: tmpHeadObj[0].CraditAmount,
        DebitAmount: tmpHeadObj[0].DebitAmount,
        OpeningBalance: tmpHeadObj[0].OpeningBalance,
        LedgerType: tmpHeadObj[0].LedgerType,
        BankName: tmpHeadObj[0].BranchName,
        Branch: tmpHeadObj[0].BranchCode,
        IFSCCode: tmpHeadObj[0].IFSCCode,
        AccountNo: tmpHeadObj[0].MICRCode,
        IsBank: tmpHeadObj[0].IsBank,
        BankID: tmpHeadObj[0].BankID
      };
    }

    this.openEditGroupModal(content, obj);

  }

  changeConfig() {
    this.isShowConfig = !this.isShowConfig;
  }

  deleteHeadFromPopup() {
    let obj: object = {
      id: this.newGroup.groupId
    }
    this.deleteGroup(obj);

  }

  editGroupName() {
    if (this.newGroup.newGroupName == '') {
      alert('Please enter group name.');
    }

    else {
      let obj = [{
        groupName: this.newGroup.newGroupName,
        groupID: this.newGroup.groupId,
        userID: 0
      }];
      // this.tree[this.tree.length - 1].headName = this.newGroup.newGroupName
      this.sendChanges(obj, 1, 'edit');
    }
  }

  editLedgerName() {
    let cust: Array<any> = []; // = $.grep(this.customers, (e: any) => { return (e.RI == Number(this.newLedger.customerId)) });
    let supp: Array<any> = []; //= $.grep(this.suppliers, (e: any) => { return (e.RI == Number(this.newLedger.supplierId)) });

    if (this.newLedger.isCustomer) {
      cust = $.grep(this.customers, (e: any) => { return (e.RI == Number(this.newLedger.customerId)) });
    }

    if (this.newLedger.isSupplier) {
      supp = $.grep(this.suppliers, (e: any) => { return (e.RI == Number(this.newLedger.supplierId)) });
    }

    if (this.newLedger.ledgerName == '') {
      alert('Please enter ledger name.');
    }

    let tmpLedger = $.grep(this.ledger, (e: any) => { return (e.LedgerName == this.newLedger.ledgerName && e.LedgerID != this.newLedger.id) });

    if (this.newLedger.accountHead == '0') {
      alert('Please select group head.')
    }

    else if (this.newLedger.ledgerName == '') {
      alert('Please enter ledger name.')
    }

    else if (tmpLedger.length > 0) {
      alert('Duplicate ledger name found.');
    }

    else if (this.newLedger.isCustomer && this.newLedger.customerId == 0) {
      alert('Please select customer.');
    }

    else if (this.newLedger.isSupplier && this.newLedger.supplierId == 0) {
      alert('Please select supplier.');
    }

    else if (this.newLedger.isBank && (!this.bank.name)) {
      alert('Please enter a bank name.');
      return;
    }

    else if (this.newLedger.isBank && (!this.bank.branch)) {
      alert('Please enter a branch.');
      return;
    }

    else if (this.newLedger.isBank && (!this.bank.ifsc)) {
      alert('Please enter a IFSC code.');
      return;
    }

    else if (this.newLedger.isBank && (!this.bank.ifsc)) {
      alert('Please enter an account number.');
      return;
    }

    else {
      let opngBal = (this.newLedger.curr == 'Cr' ? ('-' + this.newLedger.openingBal) : this.newLedger.openingBal)
      let obj = [{
        ledgerName: this.newLedger.ledgerName,
        ledgerID: this.newLedger.id,
        openingBal: String(opngBal).replace(/\,/g, ""),
        userID: 0,
        isFav: false,
        headID: this.newLedger.accountHead,
        isCustomer: this.newLedger.isCustomer,
        isSupplier: this.newLedger.isSupplier,
        isBank: this.newLedger.isBank,
        isCash: this.newLedger.isCash,
        isEmployee: this.newLedger.isEmployee,
        relID: this.newLedger.isCustomer ? cust[0].RI : this.newLedger.isSupplier ? supp[0].RI : 0,
        relAgencyID: this.newLedger.isCustomer ? cust[0].RAID : this.newLedger.isSupplier ? supp[0].RAID : 0,
        bankName: this.bank.name ? this.bank.name : '',
        branch: this.bank.branch ? this.bank.branch : '',
        IFSC: this.bank.ifsc ? this.bank.ifsc : '',
        accountNo: this.bank.accNo ? this.bank.accNo : '',
        BankID: this.bank.bankID ? this.bank.bankID : '0',
      }];

      this.sendChanges(obj, 2, 'edit');
    }
  }

  sendChanges(obj: any, moduleId: number, actionType: string) {
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: actionType,
      moduleID: moduleId,
      data: JSON.stringify(obj)
    }];

    this.apiService.sendChange(myParams, this.successGroupEntry.bind(this), this.failureResp.bind(this));
    if (this.modalReference) {
      this.modalReference.close();
    }

    if (moduleId == 1 && actionType == 'edit') {
      this.tree[this.tree.length - 1].headName = this.newGroup.newGroupName
    }

    this.resetNewGroup();
    this.resetNewLedger();

  }

  dataPush() {
    this.displayData = [];

    this.headsData.forEach((element: any) => {
      // element.CloBal < 0 ? element.ClosingBal = Math.abs(element.CloBal.replace(/\,/g,'')).toFixed(2).toLocaleString() + ' Db' : element.ClosingBal = Math.abs(element.CloBal.replace(/\,/g,'')).toLocaleString() + ' Cr';

      element.CloBal.charAt(0) == "-" ? element.ClosingBal = element.CloBal.substring(1) + ' Cr' : element.ClosingBal = element.CloBal + ' Db';
      element.CrAmt < 0 ? element.CraditAmount = Math.abs(element.CrAmt) + ' Db' : element.CraditAmount = element.CrAmt + ' Cr';
      element.DbAmt < 0 ? element.DebitAmount = Math.abs(element.DbAmt) + ' Db' : element.DebitAmount = element.DbAmt + ' Cr';
      element.OpBal < 0 ? element.OpeningBalance = Math.abs(element.OpBal) + ' Db' : element.OpeningBalance = element.OpBal + ' Cr';

      this.displayData.push({
        name: element.HeadName,
        currentBal: element.CrAmt,
        id: element.HeadID,
        parentHeadID: element.ParentHeadID,
        headLevel: element.LevelPath,
        isHead: true,
        CloBal: element.CloBal,
        CrAmt: element.CrAmt,
        DbAmt: element.DbAmt,
        OpBal: element.OpBal,
        ClosingBal: element.ClosingBal,
        CraditAmount: element.CraditAmount,
        DebitAmount: element.DebitAmount,
        OpeningBalance: element.OpeningBalance,
        LedgerType: element.LedgerType
      });
    });

    this.ledgerData.forEach((element: any) => {
      // element.CloBal < 0 ? element.ClosingBal = Math.abs(element.CloBal.replace(/\,/g,'')).toFixed(2).toLocaleString() + ' Db' : element.ClosingBal = Math.abs(element.CloBal.replace(/\,/g,'')).toLocaleString() + ' Cr';
      element.CloBal.charAt(0) == "-" ? element.ClosingBal = element.CloBal.substring(1) + ' Cr' : element.ClosingBal = element.CloBal + ' Db';
      element.CrAmt < 0 ? element.CraditAmount = Math.abs(element.CrAmt) + ' Cr' : element.CraditAmount = element.CrAmt + ' Db';
      element.DbAmt < 0 ? element.DebitAmount = Math.abs(element.DbAmt) + ' Cr' : element.DebitAmount = element.DbAmt + ' Db';
      element.OpBal < 0 ? element.OpeningBalance = Math.abs(element.OpBal) + ' Cr' : element.OpeningBalance = element.OpBal + ' Db';

      this.displayData.push({
        name: element.LedgerName,
        currentBal: element.CrAmt,
        id: element.LedgerID,
        openingBal: element.OpBal,
        isHead: false,
        balanceHistory: element.balanceHistory,
        CloBal: element.CloBal,
        CrAmt: element.CrAmt,
        DbAmt: element.DbAmt,
        OpBal: element.OpBal,
        HeadID: element.HeadID,
        IsCustomer: element.IsCustomer,
        IsFav: element.IsFav,
        IsSupplier: element.IsSupplier,
        RelAgencyID: element.RelAgencyID,
        RelID: element.RelID,
        ClosingBal: element.ClosingBal,
        CraditAmount: element.CraditAmount,
        DebitAmount: element.DebitAmount,
        OpeningBalance: element.OpeningBalance,
        LedgerType: element.LedgerType,
        BankName: element.BranchName,
        Branch: element.BranchCode,
        IFSCCode: element.IFSCCode,
        AccountNo: element.MICRCode,
        IsBank: element.IsBank,
        BankID: element.BankID,
        LedgerOpeningBal: element.LdrOpeningBal,
        IsCash: element.IsCash
      });
    });

    this.displayData.sort((a: any, b: any) => a.LedgerType - b.LedgerType);
    this.dataSource.data = this.displayData;
    this.dataSource.filterPredicate = this.createFilter();
  }

  ddlchangeYear() {
    let selectedYear;
    selectedYear = this.selectedFY.split("-")[0] + "";
    let toDate = (Number(selectedYear) + 1) + "/03/31";
    this.fn_Set_FinancialYear(toDate);
  }

  fn_Set_FinancialYear(ToDT: any) {
    var Date1 = new Date(ToDT);
    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      this.fromDate = new Date(Year + "/04/01");
      this.toDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      this.toDate = new Date(Year + "/03/31");
    }

    this.getData(1);
    //this.getData();
  }

  checkFinancialYear(date1: any, date2: any) {
    let financialYear = [];
    let fYear = new Date(date1).getFullYear();
    let lYear = new Date(date2).getFullYear();
    let toValueCheck = lYear;
    if (fYear == lYear) {
      let fMonth = new Date(date1).getMonth() + 1;
      if (fMonth < 4) {
        fYear = fYear - 1;
      }
      else {
        fYear = fYear;
      }
      let lMnth = new Date(date2).getMonth() + 1;
      if (lMnth > 3) {
        toValueCheck = lYear + 1;
      }

    }
    else {
      let fMonth = new Date(date1).getMonth() + 1;
      if (fMonth < 4) {
        fYear = fYear - 1;
      }
      else {
        fYear = fYear;
      }

      let lMnth = new Date(date2).getMonth() + 1;
      if (lMnth > 3) {
        toValueCheck = lYear + 1;
      }
    }


    for (var i = fYear; i < toValueCheck; i++) {
      financialYear.push({ 'FY': this.getCurrentFinancialYear('1-Apr-' + i) })
    }
    return financialYear;
  }

  getCurrentFinancialYear(fromDT: any) {
    var fiscalyear = "";
    var today = new Date(fromDT);
    if ((today.getMonth() + 1) < 4) {
      fiscalyear = (today.getFullYear() - 1) + "-" + today.getFullYear()
    } else {
      fiscalyear = today.getFullYear() + "-" + (today.getFullYear() + 1)
    }
    return fiscalyear
  }

  deleteGroup(object: any) {
debugger
  let gstinLedgerList = this.apiService.getCookie('ERP_Cfg');
    if (gstinLedgerList) {
     let gstinLedger =  JSON.parse(gstinLedgerList);
     this.GSTLedgerList  = gstinLedger[0].GSTLedgers;
    }

    if(this.GSTLedgerList){
      this.GSTLedgerList = JSON.parse(this.GSTLedgerList);
      if(this.GSTLedgerList.length > 0){
        this.GSTLedgerList = this.GSTLedgerList[0].GSTLedgers
        this.GSTLedgerList  = $.grep(this.GSTLedgerList, function(o: any){ return o.ledgerID == object.id });
      }
      if(this.GSTLedgerList.length > 0){
        alert("This ledger cannot be deleted because of it is link with GST.")
        this.GSTLedgerList = [];
        return;
      }
  }

    if (confirm("Do you wish to delete this " + (object.isHead == false ? 'ledger' : 'group') + "?")) {

      if (object.isHead == false) {
        var tempData = [{
          'ledgerID': object.id
        }]
        let myParams = [{
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          myLastSyncDT: null,
          isWeb: true,
          ForERPAgencyID: this.agencyData[0].ERPAgencyID,
          actionType: 'delete',
          moduleID: 2,
          data: JSON.stringify(tempData)
        }];
        this.SpinnerService.show();
        this.apiService.sendChange(myParams, this.successDelete.bind(this), this.failureDelete.bind(this));
      }
      else {
        var tmpData = [{
          'groupID': object.id
        }]
        let myParams = [{
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          myLastSyncDT: null,
          isWeb: true,
          ForERPAgencyID: this.agencyData[0].ERPAgencyID,
          actionType: 'delete',
          moduleID: 1,
          data: JSON.stringify(tmpData)
        }];
        this.SpinnerService.show();
        this.apiService.sendChange(myParams, this.successDelete.bind(this), this.failureDelete.bind(this));
      }
    }
  }

  failureDelete(res: any) {
    this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  //successResp - success  get handler
  successDelete(res: any) {
    this.SpinnerService.hide();
    if (this.modalReference) {
      this.modalReference.close();
    }
    if (res.error) {
      alert(res.message);
      this.getData(1);
    }
    else {
      this.getData(1);
      alert(res.message);
    }
    setTimeout(() => {
      this.treeIndex(this.tree[this.tree.length - 1], this.tree.length - 1, false)
    }, 1000);
  }

  // ADD button for new model open add group and subgroup :-
  openGroupSubGroup(content: any) {
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'add-group-subgroup', backdrop: 'static', keyboard: false });
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // Admin settings open model :-
  // adminsettings(content: any) {
  //   this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'adminsettings', backdrop: 'static', keyboard: false });
  //   this.modalReference.result.then((result: any) => {
  //     this.closeResult = `Closed with: ${result}`;
  //   }, (reason: any) => {
  //     this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  //   });
  // }

  AddfavLedger(obj: any) {
    var ledger = this.apiService.getCookie('Ledger');
    if (ledger) {
      this.ledgersData = JSON.parse(ledger);
    }
    if (this.ledgerData.length > 0) {
      this.favLedgerList = this.ledgersData.filter((u: any) => u.IsFav == true);
    }

    if (obj.IsFav == false) {
      if (this.favLedgerList.length >= 5) {
        // if (obj.IsFav == false) {
        alert("You can add only 5 ledger")
      } else {
        if (obj.IsFav == true) {
          this.isFav = false;
        } else {
          this.isFav = true;
        }

        this.appService.updateData(obj);
        let opBal = parseFloat(obj.OpBal.replace(/,/g, ''));
        opBal = Number(opBal);

        let Fav = [{
          LedgerID: obj.id,
          IsFav: this.isFav,
        }];

        let myParams = [{
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          myLastSyncDT: null,
          isWeb: true,
          ForERPAgencyID: this.agencyData[0].ERPAgencyID,
          actionType: 'FavLed',
          moduleID: 2,
          data: JSON.stringify(Fav)
        }];
        this.apiService.sendChange(myParams, this.successFavEdit.bind(this), this.failureDelete.bind(this));

      }
    } else {
      if (obj.IsFav == true) {
        this.isFav = false;
      } else {
        this.isFav = true;
      }

      this.appService.updateData(obj);
      let opBal = parseFloat(obj.OpBal.replace(/,/g, ''));
      opBal = Number(opBal);

      let FavUpdate = [{
        LedgerID: obj.id,
        IsFav: this.isFav,
      }];

      let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'FavLed',
        moduleID: 2,
        data: JSON.stringify(FavUpdate)
      }];
      this.apiService.sendChange(myParams, this.successFavEdit.bind(this), this.failureFavEdit.bind(this));
    }
  }

  successFavEdit(res:any){
    if (res.error) {
      alert(res.message);
    }
    else {
      this.getData(2);
      alert(res.message);
    }
  }
  failureFavEdit(res:any){
      alert(res.message);
  }

  //clickHideZero() -> hide zero the set cookie
  clickHideZero(){
    this.apiService.setCookie("hideZero", this.hideZeroLevelLdgr);
  }

  //qty with prcn
  onlyNumberAlllow = () => {
    this.newLedger.openingBal = this.CmnService.PrecisionwiseValue(this.newLedger.openingBal, 2)
  }

  // getBankData() - get all getBankData databse
  getBankData(){
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getConfig',
        moduleID: 6,
        data: ''
    }];
    this.apiService.getData(myParams, this.successRespBankData.bind(this), this.failureRespBankData.bind(this));
    }


     //successResp - success  get handler
     successRespBankData(res: any) {
      if (res.error) {
      }
      else {
          if (res) {
              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData.Table2) {
                let tempData: any = [];
                tempData = reponseData.Table2[0].BankLedgers;

              //  let bankList = this.apiService.getCookie("ERP_Cfg");
              //   if (bankList) {
              //   bankList = JSON.parse(bankList)[0].BankLedgers;
              //   if (bankList) {
              //     this.bankList = JSON.parse(bankList);
              //   }
              // }
              let bankList = this.apiService.getCookie('ERP_Cfg');
              if (bankList) {
                bankList = JSON.parse(bankList);
                let bankUpdatedData: any = [];  
               bankUpdatedData = bankList; 
                if (bankUpdatedData.length > 0) {
                 bankUpdatedData[0].BankLedgers = tempData;
                }
                this.apiService.setCookie('ERP_Cfg', JSON.stringify(bankUpdatedData));
              }
             }
          }
      }
  }

  //failureResp - failure handler
  failureRespBankData(res: any) {
    if (res.error) {
    }
  }

  expandView(head: any) {
    let isLive = this.apiService.fn_isLiveURL()
    let target: string = "_blank";
    if(!this.isWeb){
      target = "_self";
    }
    let fromDT = new Date(this.fromDate).customFormat("#DD#-#MMM#-#YYYY#");
    let toDT = new Date(this.toDate).customFormat("#DD#-#MMM#-#YYYY#");
    let redirectLink  = '';
    if(head.isHead) {
      let headID = head.id;
      redirectLink = (isLive ? '/ERP' : '') + '/HeadRecord?hid=' + encodeURIComponent(headID) + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT) 
    }
    else {
      let ledgerID = head.id;
      redirectLink = (isLive ? '/ERP' : '') + '/LedgerRecord?lid=' + encodeURIComponent(ledgerID) + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT)
    }
    window.open(redirectLink, target);
    
  }
  removeCookie(cName: string) {
    if (cName) {
      localStorage.removeItem(cName);
    }
  }

	// openAskAcctStartDT() - Open modal for setting account start date.
	openAskAcctStartDT() {
		this.modalReference = this.modalService.open(SetAcctStartDateComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'acct-start-date-mdl', backdrop: 'static', keyboard: false });
		this.modalReference.componentInstance.setAcctDTModalRef = this.modalReference;
        this.modalReference.result.then((result: any) => {
		    if (result == 'success') {
                var ledger = this.apiService.getCookie('Ledger');
                if (ledger) {
                    this.ledgersData = JSON.parse(ledger);
                }
                this.openLedgerModal(this.ledgerEntryMdl, true);
            }
		}, (reason: any) => {
			this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		});
	}
}
